<script setup>
  import { storeToRefs } from "pinia";
  import { useSurveyStore } from "@stores/survey/survey";
  import { useSurveyCardsStore } from "@stores/survey/surveyCards";
  import { computed } from "vue";

  const { survey } = storeToRefs(useSurveyStore());
  const { cards, questionCount, cardSubTypesInfos, cardTypesGroups, isFilterActive } = storeToRefs(
    useSurveyCardsStore(),
  );
  const { isCardFilteredOut } = useSurveyCardsStore();
  const cardsWithoutGen = computed(() => cards.value.filter((card) => !card.token.includes("_gen")));
</script>

<template>
  <!-- survey -->
  <RouterView
    :survey="survey"
    :cards="cardsWithoutGen"
    :question-count="questionCount"
    :card-sub-types-infos="cardSubTypesInfos"
    :card-types-groups="cardTypesGroups"
    :is-card-filtered-out="isCardFilteredOut"
    :is-filter-active="isFilterActive"></RouterView>
</template>
